import { PhoneNumberUtil } from '@ecm/material';
import { Contract } from '@ecm/portfolio';

import { ContractRoleEnum } from '../../../api/contract/role.enum';
import { StatusEnum } from '../../../api/contract/status.enum';
import { ClientTypeEnum } from '../../../api/dashboard/forbidden/clientType.enum';
import { Forbidden } from '../../../api/dashboard/forbidden/forbidden';
import { ForbiddenViewModel } from '../../../model/home/forbidden/forbidden.view-model';
import { ForbiddenDataMapper } from './forbidden-data.mapper';

const extractContratInfos = (contract: Contract) => {
    const holderNameInfo =
        contract.holder.firstName && contract.holder.lastName && contract.role === ContractRoleEnum.GESTIONNAIRE
            ? `Titulaire : ${contract.holder.firstName} ${contract.holder.lastName}`
            : null;
    return {
        publicLineNumber: PhoneNumberUtil.getFormattedPhone(contract.telco?.publicNumber) as string,
        city: contract.contractInstallationArea?.city,
        holderNameInfo: holderNameInfo,
    };
};

export const ForbiddenViewModelMapper = {
    getForbiddenViewModel: (
        forbiddenType: ClientTypeEnum,
        forbiddenTranslation: any,
        ecmAddContractStatus: boolean,
        contract?: Contract,
    ): ForbiddenViewModel => {
        const api: Forbidden = new Forbidden();
        api.cid = contract?.cid;
        api.isInQuarantine = contract?.isInQuarantine ?? false;
        api.clientType = forbiddenType;
        switch (forbiddenType) {
            case ClientTypeEnum.NSRU:
                api.title = forbiddenTranslation['nsru']['title'];
                api.text = forbiddenTranslation['nsru']['texts'];
                api.buttons = forbiddenTranslation['nsru'][ecmAddContractStatus ? 'ecmButtons' : 'buttons'];
                break;
            case ClientTypeEnum.SUGGESTED:
                api.title = contract.offerName;
                api.subtitle = forbiddenTranslation['suggested']['subTitle'];
                api.text = forbiddenTranslation['suggested']['texts'];
                api.buttons = forbiddenTranslation['suggested'][ecmAddContractStatus ? 'ecmButtons' : 'buttons'];
                api.contractInfos = extractContratInfos(contract);
                break;
            case ClientTypeEnum.SHAREDSERVICES:
                api.buttons = forbiddenTranslation['sharedServices']['buttons'];
                api.banner = forbiddenTranslation['sharedServices']['banner'];
                break;
            case ClientTypeEnum.PROTECTEDHOUSE: {
                const isProtectedHouseV2 = contract.security['version'] === 2;
                const protectedHouseTranslation = isProtectedHouseV2
                    ? forbiddenTranslation['protectedHouseV2']
                    : forbiddenTranslation['protectedHouse'];
                if (contract.status === StatusEnum.ACTIVE) {
                    api.title = protectedHouseTranslation['activeTitle'];
                    api.text = protectedHouseTranslation['texts'];
                    api.buttons = protectedHouseTranslation['buttons'];
                    api.isProtectedHouseV2 = isProtectedHouseV2;
                    api.banner = protectedHouseTranslation['banner'];
                } else if (contract.status === StatusEnum.RETRACTED) {
                    api.title = protectedHouseTranslation['retractedTitle'];
                    api.text = [];
                    api.buttons = [];
                    if (isProtectedHouseV2) {
                        api.isProtectedHouseV2 = isProtectedHouseV2;
                        api.banner = protectedHouseTranslation['banner'];
                    }
                } else {
                    api.title = protectedHouseTranslation['terminatedTitle'];
                    api.text = [];
                    api.buttons = [];
                }
                api.subtitle = contract.offerName;
                api.detail = protectedHouseTranslation['detail'] + contract.cid;
                break;
            }
            case ClientTypeEnum.TERMINATED: {
                api.title = contract.offerName;
                api.buttons = forbiddenTranslation['terminatedContract']['buttons'];
                api.changeUniverse = ForbiddenDataMapper.getChangeUniverseViewModel(
                    forbiddenTranslation['terminatedContract']['changeUniverse'],
                    contract,
                );
                api.contractInfos = extractContratInfos(contract);
                break;
            }
        }
        return ForbiddenDataMapper.extractForbiddenContract(api);
    },
};
